import { ErrorBoundary } from 'react-error-boundary'
import { AppRouter } from './configs/router'
import { QueryClientProvider } from '@tanstack/react-query'
import queryClient from './configs/reactQuery'
import ErrorFallback from './components/layouts/base/ErrorFallback'
import { Suspense } from 'react'
import { ToastContainer, type ToastContainerProps } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { defaultToastOptions } from './lib/utils'

export const App = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <QueryClientProvider client={queryClient}>
          <AppRouter />
          <ToastContainer {...(defaultToastOptions as ToastContainerProps)} />
        </QueryClientProvider>
      </ErrorBoundary>
    </Suspense>
  )
}

export default App
